import AsyncStorage from "@react-native-async-storage/async-storage";
import { inAppBrowserFunc } from "./inAppBrowser/inAppBrowser";
import { useSelector, useDispatch } from "react-redux";
import { setClientId, setConnectorIP, setGoHome, setInitAppLogout, setRenderApp, setShowOfflineMessage } from "../Redux/Reducers/appConfigReducer";
import { current_client_config } from "../config/Constant";
import { setLocationSelectErrorPopup } from "../Redux/Reducers/hotelSelectorReducer";

export const handleLocationSelect = (hotelData, callback, continueAnyway=false) => {
  return async (dispatch, getState) => {
    const { isOnline, isLoggedIn } = getState().appConfigSlice;
    const { preCheckInCompleted } = getState().checkInSlice.preCheckInStatus;

    if (Object.keys(hotelData).length === 0) {
      callback({status: "NO_HOTEL_DATA"});
      return;
    }

    if(!isOnline) {
        dispatch(setShowOfflineMessage(true));
        callback({status: "OFFLINE"});
        return;
    }

    const current_hotel_code = current_client_config.replace("GJ_", "").toUpperCase();

    if (hotelData.hotelPropertyKey === current_hotel_code) {
      callback({status: "ALREADY_AT_SELECTED_HOTEL"});
    } else {
      if (hotelData.hotelIsAppSupported) {

        if(!continueAnyway && isLoggedIn){
          callback({status: "IS_LOGGED_IN"});
          dispatch(setLocationSelectErrorPopup({
            isVisible: true,
            selectedHotel: hotelData
          }))
          return;
        }

        // if(!continueAnyway && preCheckInCompleted){
        //   callback({status: "IS_PRE_CHECKED_IN"});
        //   return;
        // }

        const clientId = hotelData.hotelPropertyKey ? `GJ_${hotelData.hotelPropertyKey}` : "";
        await dispatch(setConnectorIP(hotelData.hotelServerBaseUrl));
        await dispatch(setClientId(clientId));

        dispatch(setInitAppLogout(true));

      } else {
        callback({status: "OPENING_INAPPBROWSER"});
        inAppBrowserFunc(hotelData.hotelServerBaseUrl);
      }
    }
  };
};